export default __webpack_public_path__ + "static/logo-5141436c8b1ed476cc4ebe32d2e6278b.svg";